export default {
  header: 'Meniu',
  tabs: {
    menu: 'Meniu',
    modifier_groups: 'Modificatori',
  },
  toasts: {
    failed_to_load_data: 'Nu s-a putut încărca meniul. Reîmprospătați și încercați din nou',
  },
};
